import toastr from "toastr";
import queryString from "query-string";
import qs from "querystring";

/* CONSTANTS */

const getToday = new Date();

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/* CONSTANTS */

export const getErrorMessage = e => {
  if (!!e.response && !!e.response.data) {
    if (e.response.status !== 500) {
      for (let key in e.response.data) {
        // console.log(e.response);
        const val = e.response.data[key];
        return Array.isArray(val) ? val[0] : val;
      }
    } else if (e.response.data?.data && typeof e.response.data?.data == 'string') {
      return e.response.data;
    } else {
      return "Something went wrong";
    }
  } else if (typeof e === "string") {
    return e;
  } else if (!!e.data) {
    return e.data;
  }
};

export const getListByPermissions = (data = [], permissions = {}) => {
  return data.filter(i => {
    if (!i.permission) {
      return true;
    } else if (Array.isArray(i.permission)) {
      return i.permission.some(p => permissions[p]);
    } else {
      return permissions[i.permission];
    }
  });
  // return data.filter(i => !i.permission || permissions[i.permission]);
};

toastr.options = {
  debug: false,
  positionClass: "toast-top-right",
  onclick: null,
  fadeIn: 300,
  fadeOut: 1000,
  timeOut: 5000,
  extendedTimeOut: 1000,
};

export const showErrorMessage = text => {
  if (typeof text !== "string") text = getErrorMessage(text);
  toastr.error(text);
};

export const showSuccessMessage = text => {
  toastr.success(text);
};

export const showInfoMessage = text => {
  if (typeof text !== "string") text = getErrorMessage(text);
  toastr.info(text);
};

export const FIELD_STATUS = {
  INITIAL: "INITIAL",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
};

export const getInitialSelectParams = (data = {}) => ({
  status: FIELD_STATUS.INITIAL,
  value: null,
  ...data,
});

export const DEFAULT_REPORT_WIDGET_FIRST = [
  {
    icon: "mdi mdi-eye-check-outline",
    title: "Impressions",
    value: 0,
    badgeValue: `Undefined`,
    color: "danger",
    desc: "From previous period",
    type: "WITH_DIFFERENCE",
  },
  {
    icon: "mdi mdi-cursor-default-click-outline",
    title: "Clicks",
    value: 0,
    badgeValue: `Undefined`,
    color: "danger",
    desc: "From previous period",
    type: "WITH_DIFFERENCE",
  },
  {
    icon: "mdi mdi-contactless-payment-circle-outline",
    title: "Payment",
    value: 0,
  },
  {
    icon: "mdi mdi-cash-100",
    title: "Spend",
    value: 0,
  },
  {
    icon: "mdi mdi-cash-plus",
    title: "Profit",
    value: 0,
  },
]

export const getDefaultValueForSelect = value => {
  if (!value) return undefined;
  if (value?.value) return value;

  if (Array.isArray(value)) {
    return value.map(i => ({ value: i, label: i }));
  } else
    return {
      value,
    };
};

export const parseFormData = params => {
  let data = {
    ...params,
  };

  for (const key in data) {
    if (data[key] === "") {
      delete data[key];
    } else if (Array.isArray(data[key])) {
      data[key] = data[key].map(i => i.value);
    } else if (data[key]?.value) {
      data[key] = data[key].value;
    } else if (data[key]?.value === 0) {
      data[key] = 0;
    } else if (!!Number(data[key])) {
      data[key] = +data[key];
    }
  }
  //console.log(data);
  return data;
};

export const convertDocsToTreeData = data => {
  // console.log(data);
  if (!Array.isArray(data)) return [];

  const res = {
    id: 0,
    children: {},
  };
  data.forEach(i => {
    let prev = res;
    const path = i.prefix.split("/");
    const name = path.pop();
    path.forEach(p => {
      if (!prev.children[p]) {
        prev.children[p] = {
          id: "__folder" + Math.round(Math.random() * 100000),
          parent: prev.id,
          droppable: true,
          children: {},
        };
      }
      prev = prev.children[p];
    });
    prev.children[name] = {
      ...i,
      parent: prev.id,
    };
  });
  // console.log("RESULT", res);

  const arr = [];
  const resultToTreeData = (dt, key) => {
    if (dt && dt.id !== 0) {
      arr.push({ ...dt, title: key });
    }
    if (dt?.children) {
      for (const key in dt.children) {
        resultToTreeData(dt.children[key], key);
      }
    }
  };
  resultToTreeData(res);
  // console.log("LKOG", arr);
  arr.forEach(i => {
    if (i.children) {
      delete i.children;
    }
  });
  // console.log(arr);
  return arr;
};

export const getDaysArray = (start, end) => {
  for (
    var arr = [], dt = new Date(start);
    dt <= end;
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(new Date(dt));
  }
  return arr;
};

export const getFirstDayOfMonth = () => {
  let now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 2).toJSON().split("T")[0];
};
export const getCurrentDay = () => new Date().toJSON().split("T")[0];
export const getSelectedDaysAgo = days => {
  let oldDate = new Date();
  oldDate.setDate(oldDate.getDate() - days);
  return oldDate.toJSON().split("T")[0];
};
export const getSelectedMonthAgoWithFirstDay = months => {
  let now = new Date();
  return new Date(now.getFullYear(), now.getMonth() - months, 2).toJSON().split("T")[0];
};
export const getSelectedMonthAgoWithLastDay = months => {
  let now = new Date();
  return new Date(now.getFullYear(), now.getMonth() - months, 1).toJSON().split("T")[0];
};
export const getSelectedMonthAgo = months => {
  let oldDate = new Date();
  oldDate.setMonth(oldDate.getMonth() - months);
  return oldDate.toJSON().split("T")[0];
};

export const formatNumbersForTable = x => {
  if (x === null || x === undefined) {
    return "N/A";
  } else {
    if (Number(x) % 1 === 0) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      if (typeof x !== "string") {
        return x
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
};

export const formatNumbersForTableWithFixed = (x, fixed = 1) => {
  if (x === null || x === undefined) {
    return "N/A";
  } else {
    if (Number(x) % 1 === 0) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      if (typeof x !== "string") {
        return x
          .toFixed(fixed)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
};

export const getInitialDate = (query_name, or = new Date()) => {
  const parsed = queryString.parse(window.location.search);

  let date;
  try {
    date = Date.parse(parsed[query_name]) ? new Date(parsed[query_name]) : or;
  } catch (e) {
    date = or;
  }

  return date instanceof Date
    ? date.toISOString().split("T")[0]
    : new Date().toISOString().split("T")[0];
};

export const numberWithCommas = x => {
  if (Number(x) % 1 === 0) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    if (typeof x !== "string") {
      return x
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};

export const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const hardCompareArray = (a1, a2) => {
  return a1.length == a2.length && a1.every((v, i) => v === a2[i]);
};

export const changeQuery = obj => {
  const options = {
    arrayFormat: "bracket",
    skipEmptyString: true,
  };

  const parsed_search = queryString.parse(window.location.search, options);
  let str = queryString.stringify(
    {
      ...parsed_search,
      ...obj,
    },
    options
  );
  if (str.length > 0) str = `?${str}`;
  const url = `${window.location.pathname}${str}`;
  window.history.replaceState(null, "", url); // change match param app_id (without reload)
  return str;
};

export const download = (url, name) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = name || url.split("/").pop();
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const copyToClipboard = str => {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

export const formattedObjectsForFilter = (data, type, param = "default") => {
  let params = [];
  if (param === "default" && Object.keys(data).length > 0) {
    Object.entries(data[type]).forEach(([key, val]) => {
      params.push({
        id: key,
        name: val,
      });
    });
  } else if (param !== "default" && Object.keys(data).length > 0) {
    Object.entries(data[type]).forEach(([key, val]) => {
      params.push({
        id: val,
        name: val,
      });
    });
  }
  return params;
};


export const downloadCSVReactTable = (data, columns, fileName = 'table') => {
  const separator = ",";
  const keys = Object.keys(data[0]);
  const csvContent =
    "data:text/csv;charset=utf-8," +
    keys.join(separator) +
    "\n" +
    data
      .map((item) => {
        return keys.map((key) => {
          return item[key];
        }).join(separator);
      })
      .join("\n");
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${fileName}.csv`);
  document.body.appendChild(link);
  link.click();
};

export const getColorsAllRGB = [
  "#556ee6", "#FF6138", "#3A89C9", "#D9BF77", "#3A506B", "#3E5C76", "#335C67", "#1C3144", "#404E4D", "#D7816A",
  "#FFDDC1", "#FFABAB", "#FFC3A0", "#FF677D", "#D4A5A5", "#392F5A", "#31A2AC", "#61C0BF", "#6B4226", "#D9BF77",
  "#FDE2E2", "#C0D860", "#FFE74C", "#7A9E9F", "#343434", "#9E9E9E", "#C9C9C9", "#EFEFEF", "#2A2B2A", "#605856",
  "#ACD8AA", "#FFE156", "#6A0572", "#AB83A1", "#FFB997", "#99B898", "#8AC6D0", "#B4D6C1", "#FF6B6B", "#5B8A72",
  "#FFF3B0", "#EBAF5D", "#A9CF54", "#1C3334", "#344B47", "#6F7D8C", "#8EA604", "#3BCCB6", "#0F5257", "#77ACF1",
  "#E8A87C", "#C38D9E", "#A5A36C", "#E1E3B2", "#C4B9A8", "#D1DBBD", "#CCC8B7", "#E3D3D3", "#D9D9D9", "#9FD356",
  "#D4C5E2", "#FFF7F8", "#FF6F61", "#355C7D", "#6C5B7B", "#C06C84", "#F67280", "#CC5552", "#DB504A", "#F57E7E",
  "#ACD8AA", "#E5E059", "#5E565A", "#C3C6B1", "#355070", "#6D597A", "#FF6138", "#3A89C9", "#D9BF77", "#3A506B",
  "#3E5C76", "#335C67", "#1C3144", "#404E4D", "#D7816A", "#F4B860", "#3E3B8F", "#A5AAD9", "#F2C2B7", "#D94A4A",
  "#6A0572", "#2E294E", "#F46036", "#E2C044", "#F1EFA5", "#F6F6F6", "#BCBABE", "#CBD3B0", "#C6A477", "#F1B24A",
  "#F16364", "#E28743", "#548C2F", "#DB4C40", "#DAC1A0", "#6A0572", "#3C1642", "#84B082", "#B7D4D3", "#F3D4A0",
  "#E2C044", "#75A1A2", "#F1E3D3", "#D7C0D0", "#7F7C82", "#F5B971", "#F2A359", "#F3A712", "#A1A0A2", "#93A8AC",
  "#6E7F80", "#C7A589", "#D9BF77", "#ACD8AA", "#FFE156", "#BE2A2C", "#1E1F26", "#5F606B", "#92DCE5", "#403B4A",
  "#8EA604", "#F0E991", "#F0B67F", "#F16B6F", "#AEDC6B", "#355070", "#6D597A", "#FF6138", "#3A89C9", "#D9BF77",
  "#3A506B", "#3E5C76", "#335C67", "#1C3144", "#404E4D", "#D7816A", "#F4B860", "#3E3B8F", "#A5AAD9", "#F2C2B7",
  "#D94A4A", "#6A0572", "#2E294E", "#F46036", "#E2C044", "#F1EFA5", "#F6F6F6", "#BCBABE", "#CBD3B0", "#C6A477",
  "#F1B24a", "#F16364", "#E28743", "#548C2F", "#DB4C40", "#DAC1A0", "#6A0572", "#3C1642", "#84B082", "#B7D4D3",
  "#F3D4A0", "#F7F48B", "#EFE5B0", "#7A9E9F", "#7F7C81", "#BC5D4C", "#E8175D", "#B73848", "#F4E1D2", "#A5C882",
  "#F3A712", "#E2C044", "#75A1A2", "#F1E3D3", "#D7C0D0", "#7F7C82", "#F5B971", "#F2A359", "#F3A712", "#A1A0A2",
  "#93A8AC", "#6E7F80", "#C7A589", "#D9BF77", "#ACD8AA", "#FFE156", "#BE2A2C", "#1E1F26", "#5F606B", "#92DCE5",
  "#403B4A", "#8EA604", "#F0E991", "#F0B67F", "#F16B6F", "#AEDC6B", "#355070", "#6D597A", "#FF6138", "#3A89C9",
  "#D9BF77", "#3A506B", "#3E5C76", "#335C67", "#1C3144", "#404E4D", "#D7816A", "#F4B860", "#3E3B8F", "#A5AAD9",
  "#F2C2B7", "#D94A4A", "#6A0572", "#2E294E", "#F46036", "#E2C044", "#F1EFA5", "#F6F6F6", "#BCBABE", "#CBD3B0",
  "#C6A477", "#F1B24A", "#F16364", "#E28743", "#548C2F", "#DB4C40", "#DAC1A0", "#6A0572", "#3C1642", "#84B082",
  "#B7D4D3", "#F3D4A0", "#F7F48B", "#EFE5B0", "#7A9E9F", "#7F7C81", "#BC5D4C", "#E8175D", "#B73848", "#F4E1D2",
  "#A5C882", "#F3A712", "#E2C044", "#75A1A2", "#F1E3D3", "#D7C0D0", "#7F7C82", "#F5B971", "#F2A359", "#F3A712",
  "#A1A0A2", "#93A8AC", "#6E7F80", "#C7A589", "#D9BF77", "#ACD8AA", "#FFE156", "#BE2A2C", "#1E1F26", "#5F606B",
  "#92DCE5", "#403B4A", "#8EA604", "#F0E991", "#F0B67F", "#F16B6F", "#AEDC6B", "#355070", "#6D597A", "#FF6138",
  "#3A89C9", "#D9BF77", "#3A506B", "#3E5C76", "#335C67", "#1C3144", "#404E4D", "#D7816A", "#F4B860", "#3E3B8F",
  "#A5AAD9", "#F2C2B7", "#D94A4A", "#6A0572", "#2E294E", "#F46036", "#E2C044", "#F1EFA5", "#F6F6F6", "#BCBABE",
  "#CBD3B0", "#C6A477", "#F1B24A", "#F16364", "#E28743", "#548C2F", "#DB4C40", "#DAC1A0", "#6A0572", "#3C1642",
  "#84B082", "#B7D4D3", "#F3D4A0", "#F7F48B", "#EFE5B0", "#7A9E9F", "#7F7C81", "#BC5D4C", "#E8175D", "#B73848",
  "#F4E1D2", "#A5C882", "#F3A712", "#E2C044", "#75A1A2", "#F1E3D3", "#D7C0D0", "#7F7C82", "#F5B971", "#F2A359",
  "#F3A712", "#A1A0A2", "#93A8AC", "#6E7F80", "#C7A589", "#D9BF77", "#ACD8AA", "#FFE156", "#BE2A2C", "#1E1F26",
  "#5F606B", "#92DCE5", "#403B4A", "#8EA604", "#F0E991", "#F0B67F", "#F16B6F", "#AEDC6B", "#355070", "#6D597A",
  "#3E3B8F", "#A5AAD9", "#F2C2B7", "#D94A4A", "#6A0572", "#2E294E", "#F46036", "#E2C044", "#F4B860"];

  const compareObjects = (object1, object2) => {
    return JSON.stringify(object1) !== JSON.stringify(object2);
  }

  export const compareArrays = (array1, array2) => {
    // if (array1.length !== array2.length) {
    //   return true;
    // }
  
    for (let i = 0; i < array1.length; i++) {
      if (!compareObjects(array1[i], array2[i])) {
        return true;
      }
    }
    return false;
  }